export default "__VITE_ASSET__7009bddc__"